import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ShieldIcon, ArrowRightIcon } from 'lucide-react';
export const AlloyGatorSection = () => {
  return <section className="py-24 bg-gradient-to-b from-[#121212] to-[#0a0a0a] relative overflow-hidden" data-id="element-60" data-mp="z8y214aj7j7o">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 z-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre-v2.png')]" data-id="element-61" data-mp="pcbiqjxut07r"></div>
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#D6281F]/5 to-transparent" data-id="element-62" data-mp="gcg0jv5vs4y8"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-[#D6281F]/5 to-transparent rounded-full blur-3xl" data-id="element-63" data-mp="1ns6xufli5ax"></div>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-64" data-mp="6neogg2gi7pj">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-65" data-mp="3orzsmqutfhbp">
          {/* Image Section with aspect ratio container */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-66" data-mp="3st1vrirusdiy">
            <div className="relative" data-id="element-67" data-mp="8zhck9a026a6">
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-68" data-mp="92lmlna5bw8r"></div>
              <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-69" data-mp="iyygal5oya3i">
                {/* Aspect ratio container */}
                <div className="relative w-full" style={{
                paddingBottom: '75%'
              }} data-id="element-70" data-mp="dxiuurzlq1kl">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg" alt="AlloyGator wielkastbeschermer geïnstalleerd op een zwarte velg" className="absolute inset-0 w-full h-full object-cover" decoding="async" data-id="element-71" data-mp="3hhnbf2e03u4t" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-72" data-mp="2yqmaw9x8fqj5"></div>
              </div>
            </div>
          </div>
          {/* Content Section */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-73" data-mp="3seicwyxv70vn">
            <div className="flex items-center mb-6" data-id="element-74" data-mp="10w3mammivux">
              <div className="bg-[#D6281F]/20 p-2 rounded-full mr-4" data-id="element-75" data-mp="11fnvxzqxwc4">
                <ShieldIcon size={28} className="text-[#D6281F]" data-id="element-76" data-mp="608pot5o7ywg" />
              </div>
              <div className="h-px flex-grow bg-gradient-to-r from-[#D6281F] to-transparent" data-id="element-77" data-mp="35fdvam5wnq4u"></div>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-78" data-mp="39fxr9meqsnpe">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F]" data-id="element-79" data-mp="3eg25t6w3b8cz">
                AlloyGator
              </span>
            </h2>
            <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-80" data-mp="tpjvwq5silhz">
              De ultieme bescherming voor uw voertuig! Onze hoogwaardige
              wielkastbeschermers zijn gemaakt van een duurzaam en flexibel
              materiaal dat uw auto beschermt tegen steenslag, roest en andere
              beschadigingen. Dankzij de eenvoudige installatie en het strakke
              design is AlloyGator de perfecte keuze voor elke autoliefhebber.
            </p>
            <div className="space-y-4 mb-8" data-id="element-81" data-mp="29f2ozv0e0d47">
              <div className="flex items-center" data-id="element-82" data-mp="24ic7d38xp9go">
                <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-83" data-mp="24hiz1xububwf"></div>
                <span className="text-white/90" data-id="element-84" data-mp="20gz2avdo1aat">
                  Beschermt tegen stoepschade en steenslag
                </span>
              </div>
              <div className="flex items-center" data-id="element-85" data-mp="1qi1ho3jd20x3">
                <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-86" data-mp="1qit16fzoo870"></div>
                <span className="text-white/90" data-id="element-87" data-mp="1ljq7frp5loec">
                  Verkrijgbaar in verschillende kleuren
                </span>
              </div>
              <div className="flex items-center" data-id="element-88" data-mp="3ktyb221d5gus">
                <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-89" data-mp="3fwpta2k4neu2"></div>
                <span className="text-white/90" data-id="element-90" data-mp="3nxx50vg5xwrj">
                  Professionele installatie door BKCustoms
                </span>
              </div>
            </div>
            <Link to="/diensten/alloygator" className="inline-flex items-center bg-white/5 hover:bg-white/10 border border-white/20 text-white px-6 py-3 rounded-md transition-all duration-300 group" data-id="element-91" data-mp="3sunu289y42p3">
              <span className="mr-2" data-id="element-92" data-mp="356me4eaftjzn">Ontdek meer over AlloyGator</span>
              <ArrowRightIcon size={16} className="transition-transform duration-300 group-hover:translate-x-1" data-id="element-93" data-mp="355baqfkwme92" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
};